import { render, staticRenderFns } from "./PlanDemo.vue?vue&type=template&id=82363d54&scoped=true"
import script from "./PlanDemo.vue?vue&type=script&lang=js"
export * from "./PlanDemo.vue?vue&type=script&lang=js"
import style0 from "./PlanDemo.vue?vue&type=style&index=0&id=82363d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82363d54",
  null
  
)

export default component.exports